<template>
<div class="video_player" 
    :id="'videoPlayer'+myPlayer" 
    element-loading-text="拼命加载中"
    v-loading="loading">
    <div class="maskEvent" @click="playBegin"
            @dblclick="fullClick"></div>
    <video 
            class="hw100"
            :id="myPlayer" 
            :src="videoPath[0]"
            :autoplay="isautoplay"
            muted
            @durationchange="videoFullTime" 
            @timeupdate="videoProgressTime"
            @click="playBegin"
            @waiting="loading=true"
            @canplay="loading=false"
            @dblclick="fullClick">
    </video>
    <div :class="fullLock?'fullMenu': 'quitMenu'" :id="'menu'+myPlayer"
     @mouseover="menuShow" @mouseleave="noMenuShow" >
        <div class="isblock" :id="'isblock'+myPlayer">
            <div class="play" @click="playBegin" >
                <img :src="fullLock?require('../assets/images/player/fullScreen/icon-play.png'):require('../assets/images/player/reduction/icon-play.png')" alt="" v-show="isplay">
                <img :src="fullLock?require('../assets/images/player/fullScreen/icon-stop.png'):require('../assets/images/player/reduction/icon-stop.png')" alt="" v-show="!isplay">
            </div>
            <div class="time" >
                <span>{{changeTime(progressTime)}}</span>
                /
                <span>{{changeTime(fullTime)}}</span>
            </div>
            <div class="videoProgress ">
                <el-slider 
                v-model="timeProgress" 
                :max="timeMax" 
                @change="playback" 
                :show-tooltip="false" 
                :class="fullLock?'sliderFull': 'sliderThree'" ></el-slider>
            </div>

            <div class="speed" 
                @mouseover="speedLock=false" 
                @mouseout="speedLock=true">
                <div @click="clarityList"  :id="'speed'+myPlayer">流畅</div>
                <ul :id="'ul'+myPlayer"
                @mouseover="speedLock=false"  
                @mouseout="speedLock=true" 
                class="ulBlock ">
                    <li @click="clarityChoice">流畅</li>
                    <li @click="clarityChoice">高清</li>
                </ul> 
            </div>
            <div class="volume" @mouseover="volumeLock=false" @mouseout="volumeLock=true">
                <span @click="volumeShow" @mouseover="tipsShow" @mouseout="notTipsShow">
                    <img :src="fullLock?require('../assets/images/player/fullScreen/icon-volume.png'):require('../assets/images/player/reduction/icon-volume.png')" alt="" v-show="!ismute">
                    <img :src="fullLock?require('../assets/images/player/fullScreen/icon-mute.png'):require('../assets/images/player/reduction/icon-mute.png')" alt="" v-show="ismute">
                </span>
                <div class="tooltip" :id="'tooltip'+myPlayer">
                    <div class="tooltip-text">该监控没有声音！</div>
                    <div class="tooltip-triangle"></div>
                </div>
                <div class="Controller" :id="'Controller'+myPlayer" @mouseover="volumeLock=false" @mouseout="volumeLock=true">
                    <span>{{volume+'%'}}</span>
                    <el-slider
                    :class="['volumeSlider', fullLock?'sliderFull':'sliderThree']"
                    v-model="volume"
                    vertical
                    :show-tooltip="false"
                    :disabled="isdisabled"
                    :height="fullLock?'100px':'60px'">
                    </el-slider>
                </div>
            </div>
            <div class="full" @click="fullClick">
                <img :src="fullLock?require('../assets/images/player/fullScreen/a-icon-exitfullscreen.png'):require('../assets/images/player/reduction/a-icon-exitfullscreen.png')" alt="" v-show="fullLock">
                <img :src="fullLock?require('../assets/images/player/fullScreen/icon-fullscreen.png'):require('../assets/images/player/reduction/icon-fullscreen.png')" alt="" v-show="!fullLock">
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as EZUIKit from "../assets/js/external/ezuikit";
export default {
name:'videoPlayer',
components: {},
    props: {
        videoPath:  Array ,
        myPlayer:String,
        videoObj:Object,
        videoWidth:Object,
        playAuto:Boolean
    },
    data() {
        return {
            lock:false,
            volume:0,
            isplay:false,
            showVolume:true,
            msg:'',
            isFull:false,
            ismute:true,
            bAntiShike:false,
            isdisabled:false,
            timeProgress:80,
            totalTime:0,
            fullTime:'',
            progressTime:'',
            timeMax:0,
            speedLock:false,
            volumeLock:false,
            fullLock:false,
            recover:true,
            beforeHeight:'',
            beforeWight:'',
            videoPlay:{},
            isLichang:true,
            fullScreenStatus:false,
            isfullClick:true,
            isautoplay:false,
            loading:true,
        };
    },
    created(){
    },
    mounted() {
        this.monitoring() // 注册监听事件
        // let that =this
        // window.onresize = function () {
        //     if(that.checkFullScreen()) {
        //         that.fullScreenStatus=true
        //         console.log('全屏状态')
        //     } else {
        //         that.fullScreenStatus=false
        //         console.log('缩小状态')
        //         console.log(that.fullLock==that.fullScreenStatus)
        //         if(that.fullLock==that.fullScreenStatus){
        //             that.fullClick()
        //         }
        //     }
        // }
        
    },
    watch: {
        //鼠标移出后ul被none
        speedLock(){
          let ul = document.getElementById('ul'+this.myPlayer);
        setTimeout(()=>{
            if(this.speedLock){
                ul.style.display = 'none';
            }
        },3000)
        },
        //鼠标移出后volume被none
        volumeLock(){
        let Controller = document.getElementById('Controller'+this.myPlayer);
        setTimeout(()=>{
            if(this.volumeLock){
                Controller.style.display = 'none';
            }
        },3000)
        },
        //监视音量变化，同时判断该监控是否有声音
        volume(){
            let video = document.querySelector('#'+this.myPlayer);
            video.volume = this.volume * 0.01;
            if(!video.webkitAudioDecodedByteCount){
                setTimeout(()=>{
                    if(video.webkitAudioDecodedByteCount){
                        this.isdisabled=false
                    }else{
                        this.isdisabled=true
                        this.volume=0
                        video.volume = this.volume * 0.01;
                    }   
                },5000)
            }
            if(video.volume===0){
                this.ismute=true
            }else{
                this.ismute=false
            } 
        },
        //监控监控视频地址，在此时设置音量等初始值
        videoPath(){
            if(this.videoPath!==''){
                let video = document.querySelector('#'+this.myPlayer);
                video.muted=false
                this.volume=0
                video.volume = this.volume*0.01;
                
            }
        },
    },
    methods: {  
        // checkFullScreen() {
        //     let isFull = document.webkitIsFullScreen || document.mozFullScreen ||
        //         document.msFullscreenElement || document.fullscreenElement
        //     if (isFull == null || isFull == undefined) {
        //         isFull = false
        //     }
        //     return isFull
        // },  
        changeAutoplay(){
            let video = document.querySelector('#'+this.myPlayer);
            video.play()
        },
        monitoring() { // 监听事件
            this.$on('childMethod', (res) => {
            let video_player=document.querySelector('#videoPlayer'+this.myPlayer);
            video_player.style.height =res[1];
            video_player.style.width = res[0];
            })
        },
        // 控件栏的显示与隐藏
        menuShow(){
            let isblock = document.getElementById('isblock'+this.myPlayer);
            let menu = document.getElementById('menu'+this.myPlayer);
            menu.style.background= 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5000) 100%)';
            isblock.style.display = 'block';
        },
        noMenuShow(){
            let isblock = document.getElementById('isblock'+this.myPlayer);
            let menu = document.getElementById('menu'+this.myPlayer);
            let Controller = document.getElementById('Controller'+this.myPlayer);
            Controller.style.display = 'none'
            menu.style.background= 'transparent';
            isblock.style.display = 'none';  
        },
        //播放事件
        playBegin(){
            let video = document.querySelector('#'+this.myPlayer);
            if (this.isplay) {  //判断是否已经播放了，如果还没播放，返回true 
                // video.play();  //触发方法，播放视频
                video.play()
                this.isplay=false; 
                setTimeout(()=>{
                    if(video.webkitAudioDecodedByteCount){
                        this.isdisabled=false
                    }else{
                        this.isdisabled=true
                        this.volume=0
                        video.volume = this.volume * 0.01;
                    }   
                },1000)   
            } else{
                video.pause(); //暂停播放。
                this.isplay=true;
            }
        },
        //清晰度控件的显示
        clarityList(){
            let ul = document.getElementById('ul'+this.myPlayer);
            if(ul.style.display === 'block'){
                ul.style.display = 'none';
            }else if(ul.style.display === 'none'||ul.style.display === ''){
                ul.style.display = 'block';
            }
            
        },
        //切换清晰度
        clarityChoice(e){
            let speed = document.querySelector('#speed'+this.myPlayer);
            let video = document.querySelector('#'+this.myPlayer);
            speed.innerHTML = e.target.innerHTML;
            if(speed.innerHTML=='流畅'){
                // this.videoObj.stop()
                // this.videoObj.play({url:'ezopen://open.ys7.com/'+this.videoPath+'/1.live'})
                this.loading=true;
                this.isautoplay=true
                this.isplay=false;
                video.src=this.videoPath[0]
                new EZUIKit.EZUIPlayer({id:this.myPlayer,autoplay:true});
                
            }else if(speed.innerHTML=='高清'){
                // this.videoObj.stop()
                //  this.videoObj.play({url:'ezopen://open.ys7.com/'+this.videoPath+'/1.hd.live'})
                this.loading=true;
                this.isautoplay=true
                this.isplay=false;
                video.src=this.videoPath[1]
                 new EZUIKit.EZUIPlayer({id:this.myPlayer,autoplay:true});
            }           
        },
        //video声音控件展示
        volumeShow(){
            let Controller = document.querySelector('#Controller'+this.myPlayer);
            let video = document.querySelector('#'+this.myPlayer)
            let muted = document.querySelector('#'+this.myPlayer).muted
            if(!this.isdisabled){
                    if(this.ismute){
                    this.ismute=!this.ismute
                    this.volume=30
                    video.volume = this.volume * 0.01;
                }else{
                    // this.ismute=!this.ismute
                    if(Controller.style.display === 'block'){
                        // this.ismute=!this.ismute
                            if(this.volume==30){
                                this.volume=0
                            }else{
                                this.volume=30
                            }
                        this.ismute=!this.ismute
                        video.volume = this.volume * 0.01;
                    }else if(Controller.style.display === 'none'|Controller.style.display === ''){
                        Controller.style.display = 'block';
                    }
                }
            }
            
            
        },
        changeVolume(){
            let video = document.querySelector('#'+this.myPlayer)
            video.volume = this.volume * 0.01;
            if(this.volume===0){
                this.ismute=true
            }else{
                this.ismute=false
            }
        },
        //监听Esc
        checkFull(){
            let isFull =  window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
            if(isFull === undefined) isFull = false;
            return isFull;
        },
        //退出全屏
        fullClick(){
        let video_player=document.querySelector('#videoPlayer'+this.myPlayer);
        let video = document.querySelector('#'+this.myPlayer)
        
        if(this.fullLock){
            this.fullLock=!this.fullLock
            video_player.style.height =this.beforeHeight+'px';
            video_player.style.width = this.beforeWight+'px';
            video_player.style.zIndex=video_player.style.zIndex-1000
            // document.exitFullscreen(); 
            if (video_player.exitFullscreen) {
                document.exitFullscreen();
            } else if (video_player.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (video_player.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
            this.$emit('idValue',[this.myPlayer,0])
        }else{
            video.play()
            this.isplay=false; 
            setTimeout(()=>{
                if(video.webkitAudioDecodedByteCount){
                    this.isdisabled=false
                }else{
                    this.isdisabled=true
                    this.volume=0
                    video.volume = this.volume * 0.01;
                }   
            },1000) 
            this.fullLock=!this.fullLock
            this.beforeHeight=video_player.offsetHeight
            this.beforeWight=video_player.offsetWidth
            video_player.style.zIndex=1000
            video_player.style.height = window.screen.height + 'px'; //获取屏幕的宽高
            video_player.style.width = window.screen.width + 'px';
            video_player.requestFullscreen(); 
            this.$emit('idValue',[this.myPlayer,1])
        }
        },
        fullClick0(){
        let video_player=document.querySelector('#videoPlayer'+this.myPlayer);
        let video = document.querySelector('#'+this.myPlayer)
        
        if(this.fullLock){
            this.fullLock=!this.fullLock
            video_player.style.height =this.beforeHeight+'px';
            video_player.style.width = this.beforeWight+'px';
            video_player.style.zIndex=video_player.style.zIndex-1000
            // document.exitFullscreen(); 
            if (video_player.exitFullscreen) {
                document.exitFullscreen();
            } else if (video_player.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (video_player.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }else{
            video.play()
            this.isplay=false; 
            setTimeout(()=>{
                if(video.webkitAudioDecodedByteCount){
                    this.isdisabled=false
                }else{
                    this.isdisabled=true
                    this.volume=0
                    video.volume = this.volume * 0.01;
                }   
            },1000) 
            this.fullLock=!this.fullLock
            this.beforeHeight=video_player.offsetHeight
            this.beforeWight=video_player.offsetWidth
            video_player.style.zIndex=1000
            video_player.style.height = window.screen.height + 'px'; //获取屏幕的宽高
            video_player.style.width = window.screen.width + 'px';
            video_player.requestFullscreen(); 
        }
        },
        //获取存好的小窗口大小
        getDom(){
            return[this.beforeHeight,this.beforeWight]
        },
        resize(){
            if(!this.checkFull()){
                let video_player=document.querySelector('#videoPlayer'+this.myPlayer);
                this.fullLock=!this.fullLock
                video_player.style.height =this.beforeHeight+'px';
                video_player.style.width = this.beforeWight+'px';
                video_player.style.zIndex=video_player.style.zIndex-1000
                // document.exitFullscreen(); 
                if (video_player.exitFullscreen) {
                    document.exitFullscreen();
                } else if (video_player.msExitFullscreen) {
                    document.msExitFullscreen();
                } else if (video_player.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
            }
            
        },
        //视频无音轨提示展示
        tipsShow(){
            let tooltip = document.querySelector('#tooltip'+this.myPlayer)
            if(this.isdisabled){
               tooltip.style.display = 'block'; 
            }
        },
        //视频无音轨提示隐藏
        notTipsShow(){
            let tooltip = document.querySelector('#tooltip'+this.myPlayer)
            if(this.isdisabled){
               tooltip.style.display = 'none'; 
            }
        },
        //对视频总时长和进度时长进行格式转化
        changeTime(initTime){
            let h=Math.floor(initTime / 3600)<10?'0' + Math.floor(initTime / 3600) : Math.floor(initTime / 3600);
            let m=(Math.floor(initTime / 60)) % 60<10?'0' + Math.floor(initTime / 60) % 60 : Math.floor(initTime / 60) % 60;
            let s=Math.floor(initTime % 60)<10?'0' + Math.floor(initTime % 60) : Math.floor(initTime % 60);
            return `${m}:${s}`
        },
        //视频总时长获取
        videoFullTime(){
            let video = document.querySelector('#'+this.myPlayer);
            this.fullTime=video.duration
            this.timeMax=video.duration
        },
        //视频进度获取
        videoProgressTime(){
            let video = document.querySelector('#'+this.myPlayer);
            if(video){
                this.progressTime=video.currentTime?video.currentTime:0
                this.timeProgress=video.currentTime?video.currentTime:0
            }
            
        },
        //拖动回放
        playback(){
            let video = document.querySelector('#'+this.myPlayer);
            video.currentTime=this.timeProgress
        }

    },
    }
</script>
<style scoped lang="scss">
    * {
            padding: 0;
            margin: 0;
        }
        .head-message{
            display: none !important;
        }
        .video_player {
            position: relative;
            width: 100%;
            height: 100%;
            margin: 0 auto;
            overflow: hidden;
        }
        .maskEvent{
            position: absolute;
            z-index: 1001;
            width: 100%;
            height: 100%;
            background: transparent;
        }
         .hw100 {
            width: 100%;
            height: 100%;
        }

        .video_player .quitMenu {
            position: absolute;
            display: inline-block;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 40%;
            z-index: 1001;
            background-color: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5000) 100%);
             .play {
                position: absolute;
                width: 30px;
                height: 30px;
                /* border: 1px solid white;
                border-radius: 10px; */
                font-size: 20px;
                color: white;
                text-align: center;
                line-height: 40px;
                border-radius:20px;
                top: 75%;
                left: 5%;
                transform: translateY(-50%);
                z-index: 100;
                cursor: pointer;
            }
            .video_player .menu .play:hover {
                color: #199DFD;
            }
            .video_player .menu .play img{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            .isblock{
                display:none;
            }
            /* .video_player .menu .play:hover {
                background-color: rgb(219, 74, 74);
            } */

            .time {
                position: absolute;
                width: 150px;
                height: 30px;
                color: white;
                font-size: 12px;
                text-align: center;
                line-height: 30px;
                top: 80%;
                left: 5%;
                transform: translateY(-50%);
            }
            .videoProgress{
            position: absolute;
            bottom: 19%;
            left: 5%;
            width:90%;
            border-radius: 4px;
            background-color: transparent;
            //video进度条样式 
            }

            /* 倍数 */
            li {
                list-style: none;
            }

            .speed {
                position: absolute;
                top: 80%;
                right: 32%;
                font-size: 10px;
                transform: translateY(-50%);
                color: white;
                text-align: center;
                line-height: 30px;
            }

            .speed div {
                width: 50px;
                height: 30px;
                /* border: 1px solid white; */
                font-size: 10px;
                border-radius: 10px;
                cursor: pointer;
            }
            .speed ul {
                position: absolute;
                width: 56px;
                height: 50px;
                top: -80px;
                left: -2px;
                font-size: 14px;
                padding: 10px 0;
                padding-bottom: 25px;
                display: none;
            }
            .speed ul li {
                padding: 0 10px;
                font-size: 12px ;
                height: 30px;
                line-height: 30px;
                background-color: #121212;
            }

            .speed ul li:nth-of-type(1) {
                border-top-left-radius: 4px;
                border-top-right-radius: 4px;
            }

            .speed ul li:nth-last-of-type(1) {
                border-bottom-left-radius: 4px;
                border-bottom-right-radius: 4px;
            }

            .speed ul li:hover {
                color: #199DFD;
            }

            .speed:hover div {
                display: block;;
            }

            /* 音量 */
            .volume {
                position: absolute;
                top: 80%;
                right: 16%;
                transform: translateY(-50%);
                color: white;
                text-align: center;
                line-height: 30px;
            }
            .volume>span {
                display: block;
                width: 50px;
                height: 30px;
                /* border: 1px solid white;
                border-radius: 10px; */
                cursor: pointer;
            }
            .volume>span  img {
            position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            /* .volume>span:hover {
                background-color: rgb(219, 74, 74);
            } */

            .volume .Controller {
                position: absolute;
                top: -110px;
                left: 10px;
                width: 30px;
                height: 100px;
                border-radius: 4px;
                background-color: #121212;
                display: none;
            }
            .tips{
                position: absolute;
                top: -60px;
                left: -40px;
                padding: 10px;
                width: 150px;
                height: 50px;
                border-radius: 4px;
                background-color: #121212;
                /* display: none; */
            }
            .tooltip {
                position: absolute;
                top: -80px;
                left: -40px;
                padding: 10px;
                display: none;
            }

            .tooltip-text {
                padding: 15px;
                width: 150px;
                background: #121212;
                border-radius: 5px;
                color: #FFF;
            }


            .tooltip-triangle {
                position: relative;
                left: 50px;
                width: calc(10px * 1.41);
                height: 10px;
                overflow: hidden;
            }


            .tooltip-triangle::before {
                content: '';
                width: 100%;
                height: 100%;
                background: #121212;
                display: block;
                transform: rotate(-45deg);
                transform-origin: left top;
    }
            .volumeSlider {
                position: absolute;
                top: 55%;
                left: 50%;
                transform: translateY(-50%) translateX(-50%);
                cursor: pointer;
            }

        
    /* 全屏 */
            .full {
                position: absolute;
                width: 50px;
                height: 30px;
                /* border: 1px solid white;
                border-radius: 10px; */
                color: white;
                text-align: center;
                line-height: 30px;
                top: 80%;
                right: 0%;
                transform: translateY(-50%);
                cursor: pointer;
            }
            .full img{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
        .video_player .fullMenu{
            position: absolute;
            display: inline-block;
            bottom: 0px;
            left: 0;
            width: 100%;
            height: 200px;
            z-index: 1001;
            background-color: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5000) 100%);
            .play {
            position: absolute;
            width: 40px;
            height: 40px;
            /* border: 1px solid white;
            border-radius: 10px; */
            font-size: 20px;
            color: white;
            text-align: center;
            line-height: 40px;
            border-radius:20px;
            top: 80%;
            left: 30px;
            transform: translateY(-50%);
            cursor: pointer;
        }
        .video_player .menu .play:hover {
            color: #199DFD;
        }
        .video_player .menu .play img{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        .isblock{
            display:none;
        }
        /* .video_player .menu .play:hover {
            background-color: rgb(219, 74, 74);
        } */
        .videoProgress{
        position: absolute;
        bottom: 25%;
        left: 1%;
        width:98%;
        border-radius: 4px;
        background-color: transparent;
        //video进度条样式 
        }
        .time {
            position: absolute;
            width: 150px;
            height: 30px;
            color: white;
            font-size: 18px;
            text-align: center;
            line-height: 30px;
            top: 80%;
            left: 100px;
            transform: translateY(-50%);
        }


        /* 倍数 */
        li {
            list-style: none;
        }

        .speed {
            position: absolute;
            top: 80%;
            right: 150px;
            font-size: 18px;
            transform: translateY(-50%);
            color: white;
            text-align: center;
            line-height: 30px;
        }

        .speed div {
            width: 50px;
            height: 30px;
            /* border: 1px solid white; */
            border-radius: 10px;
            cursor: pointer;
        }
        .speed ul {
            position: absolute;
            width: 56px;
            height: 74px;
            top: -120px;
            left: -2px;
            font-size: 14px;
            padding: 10px 0;
            padding-bottom: 25px;
            display: none;
        }
        .speed ul li {
            padding: 0 10px;
            font-size: 16px ;
            height: 37px;
            line-height: 37px;
            background-color: #121212;
        }

        .speed ul li:nth-of-type(1) {
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
        }

        .speed ul li:nth-last-of-type(1) {
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
        }

        .speed ul li:hover {
            color: #199DFD;
        }

        .speed:hover div {
            display: block;;
        }

        /* 音量 */
        .volume {
            position: absolute;
            top: 80%;
            right: 80px;
            transform: translateY(-50%);
            color: white;
            text-align: center;
            line-height: 30px;
        }
        .volume>span {
            display: block;
            width: 50px;
            height: 30px;
            /* border: 1px solid white;
            border-radius: 10px; */
            cursor: pointer;
        }
        .volume>span  img {
           position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        /* .volume>span:hover {
            background-color: rgb(219, 74, 74);
        } */

        .volume .Controller {
            position: absolute;
            top: -190px;
            width: 50px;
            height: 150px;
            border-radius: 4px;
            background-color: #121212;
            display: none;
        }
        .tips{
            position: absolute;
            top: -60px;
            left: -40px;
            padding: 10px;
            width: 150px;
            height: 50px;
            border-radius: 4px;
            background-color: #121212;
            /* display: none; */
        }
        .tooltip {
            position: absolute;
            top: -80px;
            left: -40px;
            padding: 10px;
            display: none;
        }

        .tooltip-text {
            padding: 15px;
            width: 150px;
            background: #121212;
            border-radius: 5px;
            color: #FFF;
        }


        .tooltip-triangle {
            position: relative;
            left: 50px;
            width: calc(10px * 1.41);
            height: 10px;
            overflow: hidden;
        }


        .tooltip-triangle::before {
            content: '';
            width: 100%;
            height: 100%;
            background: #121212;
            display: block;
            transform: rotate(-45deg);
            transform-origin: left top;
}
        .kong{
            position: absolute;
            top: -150px;
            width: 50px;
            height: 180px;
            background-color: transparent;
            // background-color:#121212;
            z-index:-1;
        }

        .volumeSlider {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateY(-50%) translateX(-50%);
            cursor: pointer;
            /* width: 5px;
            height: 100px;
            background-color: #ccc; */
        }

       
/* 全屏 */
        .full {
            position: absolute;
            width: 50px;
            height: 30px;
            /* border: 1px solid white;
            border-radius: 10px; */
            color: white;
            text-align: center;
            line-height: 30px;
            top: 80%;
            right: 10px;
            transform: translateY(-50%);
            cursor: pointer;
        }
        .full img{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        }
</style>
           